export default "__VITE_ASSET__CzwEjjQU__"